import React from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FaRocket, FaFire, FaArrowRight } from 'react-icons/fa';
import './PresaleBanner.css';

const PresaleBanner = () => {
  return (
    <section className="presale-banner">
      <Container>
        <Row className="align-items-center">
          <Col lg={12}>
            <div className="presale-banner-content" data-aos="zoom-in">
              <div className="presale-banner-badge">
                <FaFire className="fire-icon" />
                <span>Live Now</span>
              </div>

              <h2 className="presale-banner-title">
                <FaRocket className="rocket-icon" />
                MCGP Token Presale is Live!
              </h2>

              <p className="presale-banner-text">
                Secure your MCGP tokens at the exclusive presale rate of $0.01 —
                Limited supply available until November 30, 2025
              </p>

              <div className="presale-banner-cta">
                <Link to="/presale">
                  <Button className="presale-cta-button">
                    Join Presale Now
                    <FaArrowRight className="arrow-icon" />
                  </Button>
                </Link>
                <div className="presale-banner-note">
                  <small>Minimum $10 • Maximum $1,000 per wallet</small>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default PresaleBanner;
